/**
 * Shown on the menu items an amendment quote can't use. An amendment is defined against one
 * schedule's current state, so there is nothing sensible to carry into a template or a copy.
 */
export const AMENDMENT_QUOTE_UNAVAILABLE_REASON =
  'Not available for amendment quotes'
